export default "__VITE_ASSET__038c3607__"